import { lifiLogoUrl } from '../icons.js';
export const defaultCoinbaseConfig = {
    appName: 'LI.FI',
    appLogoUrl: lifiLogoUrl,
};
//# sourceMappingURL=coinbase.js.map